import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fc" }
const _hoisted_2 = { class: "ai-detail-cols" }
const _hoisted_3 = { class: "ai-detail-preview ai-detail-old" }
const _hoisted_4 = { class: "ai-detail-header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "ai-detail-label" }
const _hoisted_7 = { class: "ai-detail-preview ai-detail-new" }
const _hoisted_8 = { class: "ai-detail-header" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "ai-detail-label",
  style: {"margin-top":"14px"}
}
const _hoisted_11 = { class: "ai-changelist" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ai-detail-label" }, "Current version", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "ai-detail-item"
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.header), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.renderBody(item.body)
              }, null, 8, _hoisted_5)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.draftLabel) + " ", 1),
          _renderSlot(_ctx.$slots, "draft-label", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "ai-detail-item"
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.header), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.renderBody(item.body)
              }, null, 8, _hoisted_9)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.changesLabel), 1),
    _createElementVNode("ul", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changes, (c, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(c), 1))
      }), 128))
    ])
  ]))
}